import React from "react";
//#region types
import { TransactionsAmountProps } from "models/propTypes/accountingPropTypes";
import { FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, QueryStateHelper, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const TransactionsAmount: React.FC<TransactionsAmountProps> = (props) => {
  const { amount, currency, categoryName, categoryId, accountNumber, accountId, dateRange, isAccount, isAudit } = props;

  const searchParams = new URLSearchParams("");

  const categoryIdEncoder = QueryStateHelper.numberQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.CategoryId
  );
  const categoryNameEncoder = QueryStateHelper.stringQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.Category
  );
  const accountNumberEncoder = QueryStateHelper.multipleAutoCompleteItemsQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.AccountNumbers
  );
  const dateRangeEncoder = QueryStateHelper.dateRangeQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.BookingDate
  );

  const dimensionEncoder = QueryStateHelper.dimensionsQueryEncoder(
    FormFieldConstants.Accounting.FinancialReportFilter.Dimensions
  );

  const location = useLocation();
  const navigate = useNavigate();

  const dimensionSearchParams = dimensionEncoder.urlDecode(new URLSearchParams(location.search));

  React.useEffect(() => {
    if (!isAccount) {
      categoryIdEncoder.urlEncode(searchParams, undefined, categoryId);
      categoryNameEncoder.urlEncode(searchParams, undefined, categoryName);
    } else {
      accountNumberEncoder.urlEncode(searchParams, undefined, [
        { id: accountId, value: accountNumber?.toString() ?? "" },
      ]);
    }
    dateRangeEncoder.urlEncode(searchParams, undefined, dateRange);
    dimensionSearchParams && dimensionEncoder.urlEncode(searchParams, undefined, dimensionSearchParams);
    if (isAudit) {
      const auditEncoder = QueryStateHelper.booleanQueryEncoder(
        FormFieldConstants.Accounting.CompanyBooksReportFilter.IsAudit
      );
      auditEncoder.urlEncode(searchParams, undefined, isAudit);
    }
  }, [props]);

  const clickHandler = () => {
    navigate(`${UrlHelper.formatPath(`/Reports/Accounting`)}?${searchParams.toString()}`, {
      state: {
        state: { background: location },
      },
    });
  };

  const canNavigate =
    (isAccount && accountNumber !== undefined) ||
    (!isAccount && categoryId !== undefined) ||
    (isAudit && categoryId !== undefined);

  return (
    <span onClick={canNavigate ? clickHandler : undefined} className={canNavigate ? cssExports.linkText : ""}>
      {LocalizationHelperInstance.getFormattedCurrency(amount, currency, 2, 2)}
    </span>
  );
};

export default TransactionsAmount;
